import React from 'react';
import * as Styled from './styled';
import { PhoneButton } from 'components/phone-button';
import { createPhoneURI } from 'hooks/useDisplayPhone';
import PhoneIcon from 'assets/svg/phone-new.svg';
import MailIcon from 'assets/svg/send.svg';
import { useLocale } from 'locale';
import { IContactAgentValues } from 'helpers/contactFormStore';
import { SubmitContactAgentPayload } from 'store/state/app/payloads';
import { Poi } from 'utils/marketplaceRoutes';
import { ContactAgentModalSource } from 'store/state/app';
import { IContactPageSubmitVariables } from 'store/sagas/apiService/types';

export interface ContactButtonsProps {
  phone: string;
  poi: Poi;
  isContacted: boolean;
  onShowPhone: (e: React.SyntheticEvent<HTMLElement>) => void;
  handleModalOpen: () => void;
  showPhone: boolean;
  dataAttributePrefix: string;
  contactValues: IContactAgentValues;
  handleSubmitEvent?: (hasErrors: boolean, formValues: IContactPageSubmitVariables, source?: string) => void;
  onContactAgentInputClick: (eventName: string, poi: Poi) => void;
  onContactPageSubmit: (payload: SubmitContactAgentPayload) => void;
  phoneButtonLabel?: string;
  mailButtonLabel?: string;
  equalWidthButtons?: boolean;
  source?: ContactAgentModalSource;
}

export const ContactButtons: React.FC<ContactButtonsProps> = (props) => {
  const {
    dataAttributePrefix,
    handleModalOpen,
    isContacted,
    onShowPhone,
    showPhone,
    phone,
    phoneButtonLabel,
    equalWidthButtons,
    mailButtonLabel,
  } = props;

  const { t } = useLocale();

  return (
    <Styled.Root equalWidthButtons={equalWidthButtons} className="contact-buttons" data-auto={`${dataAttributePrefix}-sticky`}>
      {phone ? (
        <PhoneButton onClick={onShowPhone} href={createPhoneURI(phone)} data-auto={`${dataAttributePrefix}-button-sticky-text`} size="extraLarge">
          <PhoneIcon width={24} height={24} />
          {showPhone ? phone : phoneButtonLabel || t('contactAgentModal.callButton.desktop')}
        </PhoneButton>
      ) : null}
      <Styled.ContactButton disabled={isContacted} isInitialIconColor onClick={handleModalOpen} data-auto={isContacted ? `${dataAttributePrefix}-phone-button-modal-disabled` : `${dataAttributePrefix}-phone-button-modal`} size="extraLarge" mode="ghost">
        <MailIcon width={24} height={24} />
        {isContacted ? t('contactAgentModal.button.contacted.modeB') : (mailButtonLabel || t('contactAgentModal.button.modeB'))}
      </Styled.ContactButton>
    </Styled.Root>
  );
};
